module.exports = __webpack_public_path__ + "static/media/silver_birthday.32859338.png";